export class CouponModel {
    keyword   = '';
    role_id   = 0;
    clinic_id = 0;
}